import {
  randomString,
  getFormData,
  devOrProd,
  devOrProdFeeds,
  nuqliumDataIndexSeven,
  nuqliumDataIndexSevenFeeds,
  getInternationalPriceNuqlium
} from '../shared/utils';

const randomStringAll = randomString();
const internationalPrice = getInternationalPriceNuqlium();

/* NQ DATA API */

/* Seven Homepage */
export const sevenHomepage = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProd +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'pages',
    pagekey: 'seven-homepage-landing-page',
    'settings[mode]': 'web'
  })
};

/* Brand Focus Feed - Component 4 */
export const brandFocusFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-brand-focus-feed',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* Brands All Feed - Component 5 */
export const brandsAllFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/cats/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    id: 'brands',
    output: 'json',
    'settings[mode]': 'web',
    'includes[0]': 'url',
    'includes[1]': 'total'
  })
};

/* New Arrivals (All) Feed - Component 6 */
export const newArrivalsAllFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-new-arrivals-all-feed',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* New Arrivals (Clothing) Feed - Component 6 */
export const newArrivalsClothingFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-new-arrivals-clothing-feed',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* New Arrivals (Footwear) Feed - Component 6 */
export const newArrivalsFootwearFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-new-arrivals-footwear-feed',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* New Arrivals (Accessories) Feed - Component 6 */
export const newArrivalsAccessoriesFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-new-arrivals-accessories-feed',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* Brand Story Feed - Component 9 */
export const brandStoryFeed = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'feed',
    pagekey: 'nq-brand-story-feed',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};

/* Launches Category - Component 17 */
export const launchesCategory = {
  endPointUrl:
    'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
    devOrProdFeeds +
    '/index.php?v=' +
    randomStringAll,
  endPointPrams: getFormData({
    DataIndex: nuqliumDataIndexSevenFeeds(),
    output: 'json',
    pagetype: 'category',
    pagekey: 'web_launches',
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  })
};
